export default __webpack_public_path__ + "static/product-demo-asset_2-709950b5d1dd188726798bd74d8475c3.png";